import styled from 'styled-components'

export const WarningMessageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;

  width: 100%;
  margin-bottom: 2rem;

  padding: 2rem;
  @media (min-width: 762px) {
    padding: 2rem 3rem;
  }

  background-color: white;
  border: 1px solid rgb(216 217 220 / 1);
  border-radius: 1.6rem;
  color: black;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  p {
    margin: 0 0 1rem;
  }
`

export const WarningMessageTitle = styled.div`
  margin-bottom: 2rem;
  width: 100%;

  display: flex;
  align-items: center;
  justify-items: flex-start;

  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;

  img,
  svg {
    margin-right: 1rem;
  }
`
